import { render, staticRenderFns } from "./delete_goods_dialog.vue?vue&type=template&id=0b01a5f4&scoped=true&"
import script from "./delete_goods_dialog.vue?vue&type=script&lang=ts&"
export * from "./delete_goods_dialog.vue?vue&type=script&lang=ts&"
import style0 from "./delete_goods_dialog.vue?vue&type=style&index=0&id=0b01a5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01a5f4",
  null
  
)

export default component.exports